import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import AlertModal from "../../Components/AlertModal";
import { Link } from "react-router-dom";
import SupplierModal from "./SupplierModal";
import appclient from "../../AppClient";

const SuppliersListScreen = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const rowsPerPage = 15;

  const fetchSuppliers = () => {
    setLoading(true);
    appclient
      .get(`/suppliers/`)
      .then((response) => {
        console.log("response:", response.data);
        setSuppliers(response.data);
        setFilteredSuppliers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  useEffect(() => {
    const filtered = suppliers.filter(supplier =>
      supplier.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      supplier.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      supplier.id.toString().includes(searchTerm)
    );
    setFilteredSuppliers(filtered);
    setCurrentPage(1); // Reset to first page when search changes
  }, [searchTerm, suppliers]);

  const handleAdd = () => {
    setModalMode("add");
    setSelectedSupplier(null);
    setShowModal(true);
  };

  const handleEdit = (supplier) => {
    setModalMode("edit");
    setSelectedSupplier(supplier);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    appclient
      .delete(`/suppliers/${id}/delete/`)
      .then((response) => {
        fetchSuppliers();
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  const totalPages = Math.ceil(filteredSuppliers.length / rowsPerPage);
  const paginatedSuppliers = filteredSuppliers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between flex-wrap mb-3">
        {error && <div className="alert alert-danger">{error}</div>}
        <h2 className="mb-3" style={{ color: "darkgreen" }}>قائمة الموردين</h2>
        <button 
          className="btn" 
          onClick={handleAdd}
          style={{ backgroundColor: "darkgreen", color: "white" }}
        >
          إضافة مورد جديد
        </button>
      </div>
      
      {/* Search Bar */}
      <div className="mb-3" style={{ maxWidth: "400px" }}>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="ابحث عن مورد..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ borderColor: "darkgreen" }}
          />
          <span 
            className="input-group-text" 
            style={{ backgroundColor: "darkgreen", color: "white" }}
          >
            <FaSearch />
          </span>
        </div>
      </div>
      
      <div className="table-responsive">
        <table className="table table-bordered text-center">
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>ID</th>
              <th>اسم المورد</th>
              <th className="d-none d-md-table-cell">رقم الهاتف</th>
              <th>تاريخ آخر شراء</th>
              <th className="d-none d-md-table-cell">مجموع قيمة المشتريات</th>
              <th className="d-none d-md-table-cell"> مبلغ متبقي</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {error && <div className="alert alert-danger">{error}</div>}
            {paginatedSuppliers.length === 0 ? (
              <tr>
                <td colSpan="7">لا يوجد موردين حاليا</td>
              </tr>
            ) : (
              paginatedSuppliers.map((supplier, index) => (
                <tr key={index}>
                  <td>{supplier.id}</td>
                  <td className="text-wrap">{supplier.name}</td>
                  <td className="text-wrap d-none d-md-table-cell">
                    {supplier.phone}
                  </td>
                  <td>{supplier.dateoflastorder}</td>
                  <td className="text-wrap d-none d-md-table-cell">
                    {supplier.total_purshases}
                  </td>
                  <td className="text-wrap d-none d-md-table-cell">
                    {supplier.remaining_balance}
                  </td>
                  <td>
                    <Link
                      to={`/suppliers/${supplier.id}`}
                      className="btn mx-1 btn-info text-white"
                    >
                      <i className="far fa-eye"></i>
                    </Link>

                    <button
                      className="btn mx-1 btn-success text-white"
                      onClick={() => handleEdit(supplier)}
                    >
                      <FaEdit />
                    </button>
                    <AlertModal
                      customebutton={
                        <button 
                          className="btn mx-1 btn-danger text-white"
                        >
                          <FaTrash />
                        </button>
                      }
                      title="حذف المورد"
                      message="هل أنت متأكد من حذف هذا المورد؟"
                      myaction={() => handleDelete(supplier.id)}
                      savetitle="حذف"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
        <button
          className="btn"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{ 
            backgroundColor: currentPage === 1 ? "lightgray" : "darkgreen", 
            color: "white" 
          }}
        >
          الصفحة السابقة
        </button>
        <span className="mb-2" style={{ color: "darkgreen" }}>
          الصفحة {currentPage} من {totalPages}
        </span>
        <button
          className="btn"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{ 
            backgroundColor: currentPage === totalPages ? "lightgray" : "darkgreen", 
            color: "white" 
          }}
        >
          الصفحة التالية
        </button>
      </div>

      <SupplierModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        supplierData={selectedSupplier}
        refreshData={fetchSuppliers}
      />
    </div>
  );
};

export default SuppliersListScreen;